<ng-container *ngIf="configActive$ | async; else notActive"><ng-content /></ng-container>
<ng-template #notActive>
  <ng-container *ngIf="redirectOnDeactivated">
    <div
      fxFlex
      fxLayout="column"
      fxLayoutAlign="center center"
      fxLayoutGap="0.5rem"
      style="text-align: center; padding: 1rem">
      <h3>Hier gibt es noch nichts zu sehen</h3>
      <button mat-raised-button color="primary" (click)="toRedirect()">Zurück zur Startseite</button>
    </div>
  </ng-container>
</ng-template>
